 <template>
  <div id="top" style="padding-bottom: 200px">
    <div class="container">
      <img src="@/assets/left-arrow.svg" width="20" class="back" @click="back" />

      <transition name="window-fade">
        <div
          class="training-window"
          :class="{'just-selected': justSelected }"
          v-if="activeTraining"
        >
          <Score ref="scoreComponent" />

          <div class="window-inner">
            <div style>
              <div class="window-left">
                問題の{{hasSpace('tet dis') ? '文章' : '単語'}}
                <img
                  src="@/assets/play.svg"
                  v-show="true"
                  @click="speak"
                />
                <div class="ss-control" @dblclick="setDefaultRate">
                  <img src="@/assets/turtle.svg" class="turtle" />
                  <div class="slide-container">
                    <input
                      v-model="rate"
                      type="range"
                      min="0.1"
                      max="1.1"
                      value="0.1"
                      step="0.01"
                      class="slider"
                    />
                  </div>
                  <img src="@/assets/rabbit.svg" class="rabbit" />
                </div>
              </div>
              <div class="window-right">{{current.problemText}}</div>
            </div>
            <div style>
              <div class="window-left">モデル発音記号</div>

              <div class="window-right">
                <div
                  v-if="interimVisible || !result"
                  style="diplay: flex; flex-direction: row; flex-wrap: wrap;align-item: center"
                >
                  <div v-for="(word, index) in currentModelProns" :key="index" class="model-pron">
                    <div v-for="ph in word">{{ph.withStress}}</div>
                  </div>
                </div>

                <div v-if="!interimVisible && result" class="final speech-text">
                  <span
                    v-for="(r, index) in result.modelOutput"
                    :key="index"
                    style="display:inline-block; min-width: .5rem;position: relative"
                    :style="r.isRemoved ? 'color:#f88' : ''"
                    class="phoneme"
                    @click="goToOtherLessonPage(r.phonemeWithoutStress)"
                  >{{r.isSpace ? ' ' : r.phoneme}}</span>
                </div>
              </div>
            </div>
            <div style="flex: 1">
              <div class="window-left">意味 / 発音難度</div>

              <div class="window-right" style="font-size: 1.2rem">{{current.problem.ja}} ★★★★★</div>
            </div>

            <div style="flex: 1.5">
              <div class="window-left">
                ユーザー発音
                <img
                  src="@/assets/play.svg"
                  v-show="!interimVisible"
                  @click="playLatestAudio"
                />
                <img src="@/assets/play-grey.svg" v-show="interimVisible" style="cursor: default" />
              </div>
              <div class="window-right">
                <div class="state-indicator">
                  <Listening class="spinner" :color="indicatorState ? '#ddd' : '#f88'" />
                  <div
                    class="text"
                    :class="[{'listening': !indicatorState}, {'waiting': indicatorState}]"
                  >{{ interimVisible ? '音声入力中' : '待機中'}}</div>
                </div>
                <div
                  style="width: 100%; height: 100%; display:flex; flex-direction: column; justify-content: space-evenly; align-items:center;"
                >
                  <div v-show="interimVisible" class="interim speech-text">{{interimTranscription}}</div>
                  <!-- <transition name="zoom-fade"> -->
                  <div v-show="!interimVisible" class="final speech-text">{{finalTranscription}}</div>
                  <!-- </transition> -->
                  <ScoreGauge
                    ref="gauge"
                    class="gauge"
                    :class="[{'hide': interimVisible},{'show': !interimVisible}]"
                  />
                </div>
              </div>
            </div>
            <div style="flex: 1">
              <div class="window-left">ユーザー発音記号</div>

              <div class="window-right">
                <transition name="fade">
                  <span v-if="!interimVisible && result" class="final speech-text">
                    <span
                      v-for="(r, index) in result.userOutput"
                      :key="index"
                      style="display:inline-block; min-width: .3rem;"
                      :style="r.isAdded ? 'color:rgba(0, 50, 40, 0.6)' : ''"
                    >{{r.isSpace ? ' ' : r.phoneme}}</span>
                  </span>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <span class="close-modal" v-if="activeTraining" @click="closeModal"></span>

      <h1>{{`/${$route.query.category}/の発音を学ぶレッスン`}}</h1>

      <div class="header">
        <img class="icon" src="@/assets/video-player.svg" />
        <h2 class="text">発音解説動画</h2>
        <div class="header-description">音声認識を利用した独自の採点方法を用い、あなたの発音能力・英語力を測定します。</div>
      </div>

      <el-tooltip
        class="item"
        :open-delay="500"
        effect="dark"
        content="Webカメラを使って口元とレッスン映像と比較します"
        placement="top"
      >
        <button class="button white mirror-switch" @click="enableMirror">
          比較モードをオン
          <img src="@/assets/user.svg" />
        </button>
      </el-tooltip>

      <Videos class="videos" :videos="videos" ref="video" />

      <div class="header">
        <img class="icon" src="@/assets/pair.svg" />
        <h2 class="text">音声認識トレーニング</h2>
        <div class="header-description">音声認識を利用した独自の採点方法を用い、あなたの発音能力・英語力を測定します。</div>
      </div>

      <div style="text-align: center; margin: 10px 0">
        <div class="workbook-type-container">
          <div
            class="workbook-type"
            :class="{'active': selectedWorkbookIndex === index}"
            v-for="(workbook, index) in sortedWorkbooks"
            :key="index"
            @click="selectWorkbook(index)"
          >
            <div
              class="text"
            >{{workbook.isSentence ? `/${workbook.targetPhoneme}/の熟語・短文・文章`:`/${workbook.targetPhoneme}/が${workbook.type}にくる単語` }}</div>
            <ProgressCircle
              ref="progressCircle"
              class="progress"
              :centerColor="selectedWorkbookIndex === index ? '#555':'white'"
              :percentage="Math.ceil((resultScores.filter(result => {
                  return (
                    result.isSentence === workbook.isSentence &&
                    result.type === workbook.type &&
                    result.score >= 80
                  );
                }).length / workbook.problems.length) * 100)"
            />
          </div>
        </div>
      </div>

      <div class="workbook" v-for="(workbook, index) in sortedWorkbooks" :key="index">
        <div v-if="selectedWorkbookIndex === index" style="padding: 10px 20px;">
          <ProblemBlock
            class="problem-block"
            :problem="problem"
            :selectedLesson="selectedLesson"
            :score="resultScores.filter((result)=>{return result.text === problem.word})[0]"
            v-for="(problem, index) in workbook.problems"
            :key="index"
            @click.native="showTraining(problem, workbook)"
          />
        </div>
      </div>
    </div>
    <FooterNav />
  </div>
</template>

<script>
import pronDict from "@/utils/PronDictionary";
import SpeechRecognizer from "@/utils/SpeechRecognizer";
import SpeechSynthesizer from "@/utils/SpeechSynthesizer";
import { CLEAR_SCORE, LANG, iconType } from "@/constants";
import { sleep } from "@/utils/functions";
// import { Loading } from "element-ui";

import { speechRecorder } from "@/utils/SpeechRecorder";
import Vue from "vue";
import smoothScroll from "vue-smoothscroll";
Vue.use(smoothScroll);

const correctSE = new Audio(require("@/assets/correct.mp3"));
const incorrectSE = new Audio(require("@/assets/incorrect.mp3"));

const lessons = require("@/resources/lessons");
const workbooks = require("@/resources/workbooks");
const videos = require("@/resources/videos");

import problemResultRepo from "@/utils/ProblemResultRepository";

export default {
  name: "Lesson",
  props: ["lesson"],
  components: {
    ProblemBlock: require("./ProblemBlock").default,
    Videos: require("./Videos").default,
    Score: require("./Score").default,
    FooterNav: require("./FooterNav").default,
    Listening: require("@/components/Listening").default,
    ProgressCircle: require("@/components/ProgressCircle").default,
    ScoreGauge: require("./ScoreGauge").default
  },
  computed: {
    sortedWorkbooks(workbooks) {
      return this.workbooks.sort((a, b) => {
        return a.order - b.order;
      });
    },
    indicatorState() {
      return this.interimVisible;
    },
    width() {
      return this.windowWidth;
    }
  },
  data() {
    return {
      current: {
        problemText: "",
        problem: {
          word: "",
          ja: "",
          difficulty: 3
        }
      },
      rate: 0.9,
      trainingWindowNotified: false,
      selectedWorkbookIndex: 0,
      selectedTargetPhoneme: "",
      selectedLesson: null,
      activeTraining: false,
      activeIndex: 0,
      showOriginalPron: true,
      sr: null,
      isRecognizing: false,
      speechInfo: null,
      result: {
        modelOutput: null,
        userOutput: null
      },
      currentModelProns: [],
      userResult: null,
      interimTranscription: "　",
      finalTranscription: "",
      interimVisible: true,
      recordedList: [],
      isUserPlaying: false,
      resultScores: [],
      justSelected: true,
      workbooks: [],
      workbookTitle: "仮のタイトル",
      loadingInstance: null,
      currentWorkbook: null,
      videos: []
    };
  },
  beforeDestroy() {
    // this.sr.stopSpeechRecog();
    if (this.isRecognizing) {
      this.sr.stopRecog();
    }
    speechRecorder.clearSavedAudios();
  },
  beforeCreate() {
    // const loadingInstance = Loading.service({
    //   background: "#fff"
    // });
    // setTimeout(() => {
    //   loadingInstance.close();
    // }, 1000);
    document.body.className = "lesson-body";

    // const queryedCategory = this.$route.query.category;
    // const selectedLesson =
    //   lessons.filter(lesson => {
    //     return lesson.targetPhoneme === queryedCategory;
    //   }) || [];

    // if (!selectedLesson.length) {
    //   this.$router.replace("/dashboard");
    // }

    // const videoIds = selectedLesson[0].videos;
    // const selectedVideos = [];
    // videoIds.forEach(id => {
    //   videos.forEach(video => {
    //     if (video.id === id) {
    //       selectedVideos.push(video);
    //     }
    //   });
    // });
    // this.videos = selectedVideos;
  },
  mounted() {
    let self = this;

    const video = self.$refs.video;
    self.windowWidth = window.innerWidth;
    const queryedCategory = this.$route.query.category;

    if (!queryedCategory) {
      this.$router.replace("/dashboard");
    }

    const selectedLesson = lessons.filter(lesson => {
      return lesson.titlePhoneme === queryedCategory;
    });

    this.selectedLesson = selectedLesson[0];

    const selectedWorkbooks = workbooks.filter(workbook => {
      return workbook.targetPhoneme === queryedCategory;
    });

    this.workbooks = selectedWorkbooks;

    const videoIds = selectedLesson[0].videos;
    const selectedVideos = [];
    videoIds.forEach(id => {
      videos.forEach(video => {
        if (video.id === id) {
          selectedVideos.push(video);
        }
      });
    });
    this.videos = selectedVideos;

    this.fetchScores();

    self.sr = new SpeechRecognizer({
      component: this,
      lang: LANG.EN,
      record: false,
      compare: false
    });

    document.title = `PronAid | 発音記号/${this.$route.query.category}/を学ぶレッスンページ`;
  },
  watch: {
    resultScores() {
      console.log(this.resultScores);
      // this.fetchScores();
      if (this.$refs.progressCircle) {
        this.$refs.progressCircle.forEach(circle => {
          circle.updateData();
        });
      }
    },
    $route(to, from) {
      if (from.query.q && to.query.q) {
        this.$router.go();
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.fetchScores(to.query.category);
    // const loadingInstance = Loading.service();
    this.selectedWorkbookIndex = 0;
    let self = this;
    self.$refs.video.pause();

    const queryedCategory = to.query.category;
    // this.closeModal();
    const selectedLesson = lessons.filter(lesson => {
      return lesson.titlePhoneme === queryedCategory;
    });

    this.selectedLesson = selectedLesson[0];

    const selectedWorkbooks = workbooks.filter(workbook => {
      return workbook.targetPhoneme === queryedCategory;
    });

    console.log(queryedCategory);

    const videoIds = selectedLesson[0].videos;
    const selectedVideos = [];
    videoIds.forEach(id => {
      videos.forEach(video => {
        if (video.id === id) {
          selectedVideos.push(video);
        }
      });
    });
    this.videos = selectedVideos;

    this.workbooks = selectedWorkbooks;
    this.$SmoothScroll(document.querySelector("#top"), 1000, null, null, "y");
    document.title = `PronAid | 発音記号/${queryedCategory}/を学ぶレッスンページ`;
    // setTimeout(() => {
    //   loadingInstance.close();
    // }, 1200);
    next();
  },
  methods: {
    workbookAchieved(workbook) {
      const total = workbook.problems.length;
      const cleared = this.resultScores.filter(result => {
        return (
          result.isSentence === workbook.isSentence &&
          result.type === workbook.type
        );
      }).length;
      console.log((cleared / total) * 100);
      return (cleared / total) * 100;
    },
    enableMirror() {
      this.$refs.video.toggleMirror();
    },
    openNextPron() {},

    fetchScores(to) {
      let nextRoutePhoneme = "";
      if (to) {
        nextRoutePhoneme = to;
      } else {
        nextRoutePhoneme = this.$route.query.category;
      }
      let self = this;
      problemResultRepo
        .getLessonResults(nextRoutePhoneme)
        .then(result => {
          self.resultScores = result;
        })
        .catch(err => {
          console.log(err);
        });
    },
    selectWorkbook(workbookIndex) {
      this.selectedWorkbookIndex = workbookIndex;
      // this.fetchScores();
    },
    back() {
      this.$router.go(-1);
    },
    goToOtherLessonPage(phoneme) {
      this.fetchScores();

      // let loadingInstance = Loading.service();
      this.closeModal();
      this.$router.push({ path: "lesson", query: { category: phoneme } });
      let self = this;
      const queryedCategory = phoneme;
      const selectedLesson = lessons.filter(lesson => {
        return lesson.targetPhoneme === queryedCategory;
      });
      const selectedWorkbooks = workbooks.filter(workbook => {
        return workbook.targetPhoneme === queryedCategory;
      });

      this.workbooks = selectedWorkbooks;
      // const dict = new PronDictionary();

      this.$SmoothScroll(document.querySelector("#top"), 1000, null, null, "y");

      // speechRecorder.setMode("multiple");
      document.title = `PronAid | 発音記号/${this.$route.query.category}/を学ぶレッスンページ`;
      // setTimeout(() => {
      //   loadingInstance.close();
      // }, 1000);
    },
    generateTitle(workbook) {
      let position;
      const props = workbook.props;
    },
    setDefaultRate() {
      this.rate = 1;
    },
    speak() {
      SpeechSynthesizer.speak({
        text: this.current.problemText,
        rate: this.rate,
        sr: this.sr
      });
    },
    hasSpace(str) {
      return str.indexOf(" ") >= 0;
    },

    playLatestAudio() {
      const self = this;
      if (!self.isUserPlaying) {
        this.sr.stopOnlyRecog();
        const audio = new Audio(
          URL.createObjectURL(this.speechInfo.detail.audio)
        );
        const offset = this.speechInfo.detail.offsetDuration;
        audio.currentTime = offset / 1000 - 0.8;
        setTimeout(() => {
          audio.play();
          self.isUserPlaying = true;
          self.sr.stopOnlyRecog();
        });

        audio.addEventListener("ended", () => {
          self.isUserPlaying = false;
          self.isRecognizing = true;
          self.sr.startRecog();
        });
      }
    },
    /*
        Callback emitted after receiving speech result
    */
    addResult(result) {
      const self = this;
      if (result.detail.isFinal) {
        const text = result.detail.textOriginal;
        self.finalTranscription = result.detail.textOriginal;
        self.interimVisible = false;
        self.interimTranscription = "　";
        self.speechInfo = result;
        pronDict
          .compareSymbolFromTexts(self.current.problemText, text)
          .then(r => {
            // if(higher after promise to get prev score)
            problemResultRepo.updateProblemResult({
              text: self.current.problem.word,
              score: r.score,
              targetPhoneme: self.$route.query.category,
              isSentence: self.currentWorkbook.isSentence,
              type: self.currentWorkbook.type
            });
            self.result = r;
            let exists = false;
            let existedIndex = 0;
            self.$refs.gauge.setNewScore(r.score);
            self.resultScores.forEach((result, index) => {
              if (result.text === self.current.problem.word) {
                exists = true;
                existedIndex = index;
              }
            });
            // const higher = self.resultScores[existedIndex] < r.score;
            // console.log(higher);
            if (exists) {
              this.resultScores.splice(existedIndex, 1, {
                score: r.score,
                phoneme: self.$route.query.category,
                text: self.current.problemText
              });
            } else {
              this.resultScores.push({
                score: r.score,
                phoneme: self.$route.query.category,
                text: self.current.problemText
              });
            }
            // self.fetchScores();
          });
      } else {
        self.interimVisible = true;
        self.interimTranscription = result.detail.textOriginal;
      }
      this.$forceUpdate();
    },

    showTraining(problem, workbook) {
      // console.log(workbook);
      this.current.problemText = problem.word;
      this.currentWorkbook = workbook;
      this.current.problem = problem;
      this.justSelected = true;
      const self = this;

      this.$refs.video.pause();

      pronDict.getIpaFromSingleText(problem.word).then(result => {
        self.currentModelProns = result;
      });

      if (!this.trainingWindowNotified) {
        this.$notify.info({
          title: "トレーニングウィンドウ",
          message: "ウィンドウの外をクリックすると閉じることができます。"
        });
      }
      this.trainingWindowNotified = true;

      setTimeout(() => {
        this.justSelected = false;
      }, 0);

      this.activeTraining = true;
      self.sr.startRecog();
      this.isRecognizing = true;

      // self.$refs.scoreComponent.showIcon(iconType.CROSS, 0.8, 110, 2000);

      this.transition_name = "fade";
      document.addEventListener("speech-result", this.addResult);
    },
    closeModal() {
      this.$refs.gauge.setNewScore(null);
      this.activeTraining = false;
      // wait until modal animation ends
      setTimeout(() => {
        this.sr.stopRecog();
        this.interimTranscription = "　";
        this.finalTranscription = "";
        this.interimVisible = true;
        this.justSelected = true;
        document.removeEventListener("speech-result", this.addResult);
        this.resetUserInputRelated();
      }, 500);
    },
    resetUserInputRelated() {
      this.$set(this, "result", null);
      this.interimTranscription = "　";
    }
  }
};
</script>


<style lang="scss" scoped>
.icon,
.text {
  vertical-align: middle;
  display: inline-block;
}
.icon {
  width: 50px;
  margin-right: 10px;
  transition: 0.3s ease;
}

.container {
  @include mq(sm) {
    padding-bottom: 1000px;
  }
  @include mq(md) {
    padding-bottom: 750px;
  }

  @include mq(lg) {
    padding-bottom: 650px;
  }
  position: relative;
  padding-bottom: 900px;
  .back {
    border-radius: 50%;
    cursor: pointer;
    position: fixed;
    height: 25px;
    width: 25px;
    padding: 10px;
    color: white;
    background-color: #555;
    border: none;
    transform: translateX(-55px);
    font-size: 1.4rem;
    /* left: 100px; */
    top: 30px;
    &:hover {
      background-color: #666;
    }
  }
}

.training-window {
  width: 620px;
  height: 450px;
  font-size: 1.2rem;

  @include mq(sm) {
    width: 620px;
    height: 450px;
    /* transform: none !important; */
    /* position: absolute !important; */
  }
  @include mq(md) {
    width: 820px;
    height: 500px;
  }

  @include mq(lg) {
    width: 950px;
    height: 550px;
  }

  position: fixed;
  @include dark-shadow;
  line-height: 40px;
  z-index: 1042;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* transform: translateY(20%); */
  margin: auto;
  background-color: rgba(255, 255, 255, 1);
  font-size: 1.9rem;
  font-weight: 600;
  overflow: hidden;
  /* transition: all 0.5s ease; */
}

.model-diff {
  margin-top: 5px;
  color: rgba(0, 64, 128, 0.4);
}
.user-diff {
  position: absolute;
  left: 0;
  right: 0;
  top: 72%;
  margin: 0 auto;
  color: rgba(0, 64, 128, 0.4);
}

.close-modal {
  z-index: 220;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.lesson-item-header {
  margin: 20px 0 40px 30px;
  text-align: left;
  .header-inline {
    margin-bottom: 10px;
    .icon {
      width: 40px;
    }
    h2 {
      display: inline-block;
      vertical-align: middle;
      font-size: 1.8rem;
      margin-left: 0.2rem;
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  p {
    font-weight: bold;
    margin: 0;
  }
}

h1 {
  font-weight: 700;
  font-size: 2.1rem;
  margin: 5px 0;
  padding-bottom: 10px;
  text-align: center;
  border-bottom: 1px solid #ddd;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    width: 500px;
    height: 3px;
    background-color: #f88;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.window-inner {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 25px;
  line-height: 2.2rem;
  display: flex;
  flex-direction: column;

  div {
    &:hover {
      background-color: #fafafa;
      .window-left {
        border-right: 1px solid $main-color;
      }
    }
    display: flex;

    flex-direction: row;
    .window-left {
      box-sizing: border-box;
      transition: all 0.3s ease;
      flex-basis: 150px;
      min-width: 150px;
      font-size: 0.9rem;
      margin: 15px 0;
      @include flex-centerer-column;
      border-right: 1px solid #ddd;

      @include mq(sm) {
        font-size: 0.9rem;
      }
      @include mq(md) {
        font-size: 0.95rem;
      }

      @include mq(lg) {
        font-size: 1rem;
      }

      .ss-control {
        padding-top: 6px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        img {
          margin: 0 5px;
          width: 15px;
          height: 15px;
        }
        .turtle {
          width: 18px;
          height: 18px;
        }
      }

      img {
        cursor: pointer;
        width: 30px;
        height: 30px;
      }
    }
    .window-right {
      position: relative;
      flex: 1;
      box-sizing: border-box;
      font-size: 1.1rem;
      line-height: 1.3rem;
      padding: 10px 20px;
      text-align: center;

      @include mq(sm) {
        font-size: 1.1rem;
        line-height: 1.3rem;
      }
      @include mq(md) {
        font-size: 1.5rem;
        line-height: 2rem;
      }

      @include mq(lg) {
        font-size: 1.8rem;
      }

      @include flex-centerer-column;
      .state-indicator {
        position: absolute;
        bottom: 30px;
        right: 20px;
        /* @include centerer; */
        z-index: 0;
        @include flex-centerer-column;
        .spinner {
          transform: scale(1.8);
        }
        .text {
          font-size: 0.8rem;
          position: absolute;
          width: 100px;
          text-align: center;
          @include flex-centerer-row;
          top: 30px;
          z-index: 500;
        }
        .listening {
          color: $main-color;
        }
        .waiting {
          color: #ccc;
        }
      }

      .model-pron {
        margin-right: 0.5rem;
        letter-spacing: -1.1px;
        &:last-child {
          margin: 0;
        }
      }

      .speech-text {
        display: inline-block;
        position: relative;
        letter-spacing: -1px;
        vertical-align: middle;
        text-align: center;

        img {
          cursor: pointer;
          width: 30px;
          height: 30px;
          margin-left: 8px;
          /* position: absolute;
          right: -43px;
          top: 0;
          bottom: 0;
          margin: auto 0; */
        }
      }
    }
  }

  &:hover {
    .window-left {
      /* flex: 1; 
      
      */
    }
  }
}

.user {
  position: absolute;
  color: #555;
}
.interim {
  user-select: none;
  color: #ddd;
  filter: blur(2px);
  /* &:after {
    position: absolute;
    top: -1px;
    right: -40px;
    content: "...";
  } */
}

.problem-section-header {
  display: inline-block;
  margin: 36px 0 12px 0;
  top: 450px;
  /* margin-top: 36px; */
  /* margin-bottom: 6px; */
  padding: 12px 24px;
  font-size: 1rem;
  /* border-bottom-right-radius: 4px; */
  background-color: #999;
  color: white;
  z-index: 201;
}

// animations

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.window-fade-enter-active,
.window-fade-leave-active {
  transition: all 0.4s ease;
}
.window-fade-enter,
.window-fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

// model play
// play icon

.fade-enter-active {
  transition: all 0.3s ease;
}

.fade-enter {
  opacity: 0;
}

.slide-container {
  width: 50%;
  position: relative;
  .slider {
    width: 100%;
    cursor: pointer;
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: $main-color; /* Green background */
      cursor: pointer;
    }
  }
  /* Mouse-over effects */
  .slider:hover {
  }
}

.slider {
  -webkit-appearance: none;
  appearance: none;
  height: 3px;
  background: rgba(0, 0, 0, 0.15);
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    height: 100%;
    background-color: #f88;
    z-index: 1000;
  }
}

.phoneme {
  cursor: pointer;
  &:hover {
    transform: translateY(-2px);
  }
}

.workbook-type-container {
  font-weight: bold;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin: 0 auto;
  font-size: 0.8rem;

  @include mq(sm) {
    font-size: 0.8rem;
  }
  @include mq(md) {
    font-size: 1rem;
  }
}

.active {
  background-color: #555 !important;
  color: white !important;
}

.workbook-type {
  cursor: pointer;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 12px;
  border-right: 1px solid #ddd;
  .text {
    vertical-align: middle;
  }

  &:last-child {
    border: none;
  }
  .progress {
  }
  &:hover {
    background-color: #fafafa;
  }
}

.workbook-type-inner {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.right-control {
  display: inline-block;
  div {
    display: inline-block;
  }
}
.mirror-switch {
  border-radius: 0px 5px 0 0;
  z-index: 206;
  padding: 7px 25px;
  font-size: 0.9rem;
  img {
    margin-left: 3px;
    vertical-align: middle;
    width: 20px;
  }
}

.score {
  display: block;
}

.hide {
  opacity: 0;
}
.show {
  opacity: 1;
}

.gauge {
  transition: all 0.3s ease;
}

h3 {
  font-size: 2.6rem;
  text-transform: uppercase;
  font-weight: 900;
  letter-spacing: 8px;
  margin: 45px 0 10px 0;
  text-align: center;
  /* padding-left: 5px; */
  position: relative;
  color: #bbb;
  /* &::after {
    content: "";
    height: 40px;
    width: 3px;
    position: absolute;
    bottom: 12px;
    left: 0;
    background-color: #f88;
  } */
}

.header {
  display: inline-block;
  width: 100%;
  margin: 30px 0 0 30px;
  h2 {
    margin: 10px 0;
    font-size: 2rem;
  }
  .header-description {
    display: block;
    margin-bottom: 15px;
    font-size: 1.1rem;
    font-weight: bold;
  }
  img,
  .text {
    vertical-align: middle;
    display: inline-block;
  }

  img {
    width: 40px;
    margin-right: 10px;
  }
}
</style>


